module.exports = __webpack_public_path__ + "img/92155.59a34dd9.svg";